module.exports = __webpack_public_path__ + "img/ico_espada.a841fc3c.png";